/* eslint-disable sort-keys */
import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
import { padding } from '../../mixins/spacer';
//
// Tokens
//
export const CFBaseModalContentTokens = {
    PADDING: {
        NATIVE: {
            BODY: {
                horizontal: CFTokens.SPACER.D,
                vertical: CFTokens.SPACER.D,
            },
            FOOTER: {
                horizontal: CFTokens.SPACER.D,
                vertical: CFTokens.SPACER.B,
            },
            HEADER: {
                horizontal: CFTokens.SPACER.D,
                vertical: CFTokens.SPACER.B,
            },
        },
        WEB: {
            BODY: {
                horizontal: CFTokens.SPACER.E,
                vertical: CFTokens.SPACER.E,
            },
            FOOTER: {
                horizontal: CFTokens.SPACER.E,
                vertical: CFTokens.SPACER.B,
            },
            HEADER: {
                top: CFTokens.SPACER.B,
                right: CFTokens.SPACER.E,
                bottom: CFTokens.SPACER.NONE,
                left: CFTokens.SPACER.E,
            },
        },
    },
};
//
// Helpers
//
export const CFBaseModalContentHelpers = {};
//
// Element Styles
//
export const CFBaseModalContentStyles = {
    Body: css `
    box-sizing: border-box;
    width: 100%;
  `,
    BodyNative: css `
    ${padding(CFBaseModalContentTokens.PADDING.NATIVE.BODY)}
  `,
    BodyWeb: css `
    overflow: auto;
    flex: 1;
    ${padding(CFBaseModalContentTokens.PADDING.WEB.BODY)}
  `,
    Footer: css `
    box-sizing: border-box;
    width: 100%;
  `,
    FooterNative: css `
    ${padding(CFBaseModalContentTokens.PADDING.NATIVE.FOOTER)}
  `,
    FooterWeb: css `
    ${padding(CFBaseModalContentTokens.PADDING.WEB.FOOTER)}
  `,
    Header: css `
    box-sizing: border-box;
    width: 100%;
  `,
    HeaderNative: css `
    ${padding(CFBaseModalContentTokens.PADDING.NATIVE.HEADER)}
  `,
    HeaderWeb: css `
    ${padding(CFBaseModalContentTokens.PADDING.WEB.HEADER)}
  `,
    Root: css `
    width: 100%;
    display: flex;
    gap: 0;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
  `,
    RootWeb: css `
    flex: 1;
    overflow: hidden;
  `,
};
